<button
  (click)="buttonClick.emit($event)"
  [attr.type]="type"
  [disabled]="disabled"
  [attr.class]="
    getColorClass() +
    ' ' +
    getSizeClass() +
    ' font-medium flex justify-center items-center focus:ring-4 focus:outline-none rounded-lg text-center'
  "
>
  <app-flowbite-icon
    *ngIf="iconName"
    [iconName]="iconName"
    [iconStyle]="iconStyle"
    size="24"
    customClass="mr-2"
  ></app-flowbite-icon>
  <ng-content></ng-content>
</button>
